export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR   = 'AUTH_ERROR';
export const AUTH_LOGOUT  = 'AUTH_LOGOUT';
export const USER_REQUEST = 'USER_REQUEST';
export const AUTH_DECODE  = 'AUTH_DECODE';

export const UPLOAD_REQUEST  = 'UPLOAD_REQUEST';
export const UPLOAD_SUCCESS  = 'UPLOAD_SUCCESS';
export const UPLOAD_ERROR    = 'UPLOAD_ERROR';
export const GET_FILES       = 'GET_FILES';

export const GET_HOLIDAYS    = 'GET_HOLIDAYS';
export const GET_HOLIDAY     = 'GET_HOLIDAY';
export const GET_COUNTRIES   = 'GET_COUNTRIES';

export const GET_SOURCES  = 'GET_SOURCES';

export const POST_HOLIDAY_EXPR = 'POST_HOLIDAY_EXPR';
export const PATCH_HOLIDAY_EXPR = 'PATCH_HOLIDAY_EXPR';
export const GET_HOLIDAY_EXPR = 'GET_HOLIDAY_EXPR';
export const DESTROY_HOLIDAY = 'DESTROY_HOLIDAY';



// WEBPACK FOOTER //
// ./src/store/constants.js